import { render, staticRenderFns } from "./WebContainer.vue?vue&type=template&id=a21b6440&"
import script from "./WebContainer.vue?vue&type=script&lang=js&"
export * from "./WebContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports